import { makeGetAcademicOverviewData } from 'main/factories/usecases/reports/remote-get-academic-overview-data-factory';
import { AcademicOverview } from 'presentation/app/modules/Reports/pages/academic-overview';
import React from 'react';

export const MakeAcademicOverview: React.FC = () => {
  return (
    <AcademicOverview getAcademicOverviewData={makeGetAcademicOverviewData()} />
  );
};
